import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ComponentTool } from '../../../../../interfaces/componenttool';
import { DefaultValuesService } from '../../../../../services/defaultvalues.service';
import { Utils } from '../../../../../utils/utils';
import { ResultsDialogue } from './resultsdialogue.component';



@Component({
    selector: "searchaddon",
    templateUrl: './searchaddon.component.html',
    styleUrls: ['./searchaddon.component.less'],
    animations: [
        trigger('collapse', [
            state('show', style({ opacity: 1, height: '*', display: 'block' })),
            state('hide', style({ opacity: 0, height: '0px', display: 'none' })),
            transition('show => hide', [animate('300ms')]),
            transition('hide => show', [animate('300ms')])
        ])
    ],
    standalone: false
})

export class SearchAddon implements OnInit {
    collapsedFilters = true;

    selectedTenants: string[] = [];
    selectedTenantLabels: string[] = [];
    selectedRoles: string[] = [];
    selectedRoleLabels: string[] = [];
    selectedCdpGroups: string[] = [];
    selectedCdpGroupLabels: string[] = [];
    users: UserSummary[] = [];
    totalResultsCount: number = 0;

    queryFilter = ""
    isSearching = false;

    subscriptionStage: any;
    componentToolEnum: typeof ComponentTool = ComponentTool;

    dialogResult: MatDialogRef<ResultsDialogue, any> | undefined


    constructor(
        private readonly http: HttpClient
        , @Inject('BASE_URL') private readonly baseUrl: string
        , private readonly dialogForm: MatDialog
        , public defaults: DefaultValuesService
        , private readonly toastr: ToastrService

    ) {

    }

    ngOnInit() {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => { this.loadInformation() });
        this.loadInformation();

    }

    private loadInformation() {
        if (this.defaults.passedTenants.length > 0 && this.defaults.componentTool === this.componentToolEnum.Rulebook && !this.defaults.isDataAnalytStage()) {
            this.selectedTenants = this.defaults.passedTenants;
            this.selectedRoles = this.defaults.passedRoles;
            this.selectedCdpGroups = this.defaults.passedCdpGroups;
            this.onNgSelectChange();

        }

        else if (this.defaults.umpFilters.tenants.length === 0 && this.defaults.componentTool === this.componentToolEnum.Rulebook && !this.defaults.isDataAnalytStage()) {
            Utils.httpGetInitialFilters(
                this.http
                , this.baseUrl
                , this
                , function (tthis: SearchAddon, data: UserFilter) {
                    tthis.users = [];
                    tthis.defaults.umpFilters = data
                    tthis.selectedTenants = [tthis.defaults.umpFilters.tenants[0].value]
                    tthis.selectedRoles = [tthis.defaults.umpFilters.personas[0].value]
                    tthis.selectedCdpGroups = [tthis.defaults.umpFilters.cdpList[0].value]
                    tthis.onNgSelectChange()
                    tthis.selectAllForDropdownItems(tthis.defaults.umpFilters.tenants);

                }
            )
        }
        else if (this.defaults.componentTool === this.componentToolEnum.Rulebook && !this.defaults.isDataAnalytStage()) {
            this.selectedTenants = [this.defaults.umpFilters.tenants[0].value]
            this.selectedRoles = [this.defaults.umpFilters.personas[0].value]
            this.selectedCdpGroups = [this.defaults.umpFilters.cdpList[0].value]
            this.onNgSelectChange()
        }
    }
    selectAllForDropdownItems(items) {

        let allSelect = items => {
            items.forEach(element => {
                element['selectedAllGroup'] = 'selectedAllGroup';
            });
        };

        allSelect(items);
    }
    onNgSelectChange() {
        this.selectedTenantLabels = this.defaults.umpFilters.tenants.filter(x => this.selectedTenants.includes(x.value)).map(x => " " + x.text)
        this.selectedRoleLabels = this.defaults.umpFilters.personas.filter(x => this.selectedRoles.includes(x.value)).map(x => " " + x.text)
        this.selectedCdpGroupLabels = this.defaults.umpFilters.cdpList.filter(x => this.selectedCdpGroups.includes(x.value)).map(x => " " + x.text)
    }
    loadUsersByFilter() {

        if (this.queryFilter === '' || this.isSearching)
            return;

        this.isSearching = true;

        Utils.httpGetUsersByFilter(
            this.http
            , this.baseUrl
            , {
                "UserPrincipalName": "",
                "Page": 0,
                "PageSize": 25,
                "GivenName": this.queryFilter.trim(),
                "CdpGroup": this.selectedCdpGroups,
                "NodeId": this.selectedRoles,
                "Tenant": this.selectedTenants,
                "MailO365Account": null
            }, this
            , function (tthis: SearchAddon, data: UserList) {
                tthis.users = data.users;
                tthis.totalResultsCount = data.totalResultsCount;
                tthis.isSearching = false;
                tthis.opnedialoguebox();
            }, this.defaults.isDataAnalytStage()
            , function (tthis: SearchAddon) {
                tthis.isSearching = false;
                tthis.toastr.error('There was an error searching user. Please try again or contact the administrator.', 'Error');
            })



    }

    toggle() {
        this.collapsedFilters = !this.collapsedFilters;
    }

    expand() {
        this.collapsedFilters = false;
    }

    collapse() {
        this.collapsedFilters = true;
    }
    opnedialoguebox() {
        this.dialogResult = this.dialogForm.open(ResultsDialogue, {
            minWidth: '750px',
            data: { users: this.users, totalResultsCount: this.totalResultsCount },
            disableClose: true
        });
       
    }
}